export const urls = {
  VARATI_DELOVE: 'Delovi/delovi_pregled_i_pretraga_delova',
  VARATI_MASINE: 'Combo/vrati_masine_combo',
  GET_SLIKE_ZA_DEO: 'Dokumenta/konvertovanje_base64_sa_id',
  INSERT_DELOVI: 'Delovi/unos_delova',
  UPDATE_DELOVI: 'Delovi/izmena_delova',
  DELETE_DELOVI: 'Delovi/brisanje_dela',
  VRATI_KATEGORIJU_DELOVA: 'Combo/vrati_kategorije_delova',
};
